module.exports = __webpack_public_path__ + "img/shopping_detail_1.f9343d2a.svg";